<template>
  <MarketCategoryTable
      :items="items"
      @operation="onOperation"
  />
</template>

<script>
  import MarketCategoryTable from './MarketCategoryTable.vue';
  import {API} from "../../../../helpers/api-endpoints";
  import {Operations} from "../../../../helpers/roles";

  export default {
    name: 'MarketCategoryList',
    components: { MarketCategoryTable },
    data() {
      return {
        items: [],
      };
    },
    mounted() {
      this.load();
    },
    methods: {
      async load() {
        this.$loading(true);
        try {
          const { data } = await this.$http.post(
              API.MARKET_CATEGORY_SEARCH,
              { offset: 0, max: 50, selectFields: ['*'] }
          );
          this.items = data.resultList || [];
        } finally {
          this.$loading(false);
        }
      },

      onOperation({ type, payload }) {
        switch (type) {
          case Operations.CREATE:
            this.$router.push({ name: 'adminMarketCategoryCreate' });
            break;

          case Operations.VIEW:
            this.$router.push({
              name: 'adminMarketCategoryView',
              params: { code: payload }
            });
            break;
        }
      }
    }
  };
</script>
